import React, { useMemo } from 'react';
import { UserHoverCardContent } from '@components/Feed/User/UserHoverCardContent';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { UserHoverCard } from '@components/main-components/user/UserHoverCard';
import { webappUriPath } from '@utils/url';

export function LexicalDisplayNodesMention({
  displayText,
  userId,
  webappUri,
  showMentionsHoverCard,
}: {
  displayText: string;
  userId: string;
  webappUri: string;
  showMentionsHoverCard: boolean;
}) {
  const content = useMemo(() => {
    return (
      <AccessibleLink pathnameUri={webappUriPath(webappUri)} className="cursor-pointer">
        <span className="font-medium text-fuchsia500 hover:brightness-90">{displayText}</span>
      </AccessibleLink>
    );
  }, [displayText, webappUri]);
  return showMentionsHoverCard ? (
    <UserHoverCard
      userHoverCardContent={<UserHoverCardContent userId={userId} />}
      trigger={content}
    />
  ) : (
    content
  );
}
